import React from 'react';
import { observer, inject } from 'mobx-react';
import { TabBar } from '../../components';
import store, { UserStore, StatusStore } from '../../store';
import './Nav.less';
import { Logistics } from '../../model';
import { observable } from 'mobx';

interface NavPropType {
    prefixCls?: string;
    user?: UserStore;
    status?: StatusStore;
    activity?: any;
}


@observer
@inject('user', 'status')
class Nav extends React.Component<NavPropType> {
    static defaultProps = {
        prefixCls: 'nav'
    };

    @observable NAV_TAB_BAR_ARR: any[] = [
        {
            type: 'home',
            to: '/home',
            icon: require('../../images/home.png'),
            selectedIcon: require('../../images/home_act.png'),
            title: '首页'
        },
        {
            type: 'classification',
            to: '/classification',
            icon: require('../../images/class.png'),
            selectedIcon: require('../../images/class_act.png'),
            title: '分类'
        },
        {
            type: 'shop',
            to: '/shop',
            icon: require('../../images/shop.png'),
            selectedIcon: require('../../images/shop_act.png'),
            title: '购物车'
        },
        {
            type: 'my',
            to: '/my',
            icon: require('../../images/my.png'),
            selectedIcon: require('../../images/my_act.png'),
            title: '我的'
        }
    ];
    changeHomeStyle: any = new Logistics({url: 'home/v1/changeHomeStyle'}); // 首页换肤

    componentWillMount(): void {
        // 首页换肤
        if (store.status.homeSkin.length === 0) {
            this.changeHomeStyle.fetch((data: any) => {
                store.status.homeSkin = data;
                if (data[0].iconVO) {
                    data[0].iconVO.defaultHome && (this.NAV_TAB_BAR_ARR[0].icon = data[0].iconVO.defaultHome);
                    data[0].iconVO.home && (this.NAV_TAB_BAR_ARR[0].selectedIcon = data[0].iconVO.home);
                    data[0].iconVO.defaultClassify && (this.NAV_TAB_BAR_ARR[1].icon = data[0].iconVO.defaultClassify);
                    data[0].iconVO.classify && (this.NAV_TAB_BAR_ARR[1].selectedIcon = data[0].iconVO.classify);
                    data[0].iconVO.defaultCart && (this.NAV_TAB_BAR_ARR[2].icon = data[0].iconVO.defaultCart);
                    data[0].iconVO.cart && (this.NAV_TAB_BAR_ARR[2].selectedIcon = data[0].iconVO.cart);
                    data[0].iconVO.defaultMine && (this.NAV_TAB_BAR_ARR[3].icon = data[0].iconVO.defaultMine);
                    data[0].iconVO.mine && (this.NAV_TAB_BAR_ARR[3].selectedIcon = data[0].iconVO.mine);
                }
            });
        } else {
            if (store.status.homeSkin[0].iconVO) {
                store.status.homeSkin[0].iconVO.defaultHome && (this.NAV_TAB_BAR_ARR[0].icon = store.status.homeSkin[0].iconVO.defaultHome);
                store.status.homeSkin[0].iconVO.home && (this.NAV_TAB_BAR_ARR[0].selectedIcon = store.status.homeSkin[0].iconVO.home);
                store.status.homeSkin[0].iconVO.defaultClassify && (this.NAV_TAB_BAR_ARR[1].icon = store.status.homeSkin[0].iconVO.defaultClassify);
                store.status.homeSkin[0].iconVO.classify && (this.NAV_TAB_BAR_ARR[1].selectedIcon = store.status.homeSkin[0].iconVO.classify);
                store.status.homeSkin[0].iconVO.defaultCart && (this.NAV_TAB_BAR_ARR[2].icon = store.status.homeSkin[0].iconVO.defaultCart);
                store.status.homeSkin[0].iconVO.cart && (this.NAV_TAB_BAR_ARR[2].selectedIcon = store.status.homeSkin[0].iconVO.cart);
                store.status.homeSkin[0].iconVO.defaultMine && (this.NAV_TAB_BAR_ARR[3].icon = store.status.homeSkin[0].iconVO.defaultMine);
                store.status.homeSkin[0].iconVO.mine && (this.NAV_TAB_BAR_ARR[3].selectedIcon = store.status.homeSkin[0].iconVO.mine);
            }
        }
    }

    render() {
        const {status} = this.props;
        const CART_NUMBER: any = this.props.user && this.props.user.cartNum;
        const homeSkin: any = status && status.getHomeSkin;
        // console.log(homeSkin[0])
        return <TabBar className={`${this.props.prefixCls}`} style={homeSkin[0] ? {background: `${homeSkin[0].iconVO ? homeSkin[0].iconVO.iconBackgroundColour : ''}`} : {}} tabs={this.NAV_TAB_BAR_ARR} number={CART_NUMBER} />;
    }
}

export default Nav;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/common/Nav.tsx